
import React from "react";
const InvoicesIcon = (props) => {
  return (
    <img src="/images/nuevo_ico_facturas.png" alt=""/>
  );
}
export default InvoicesIcon;
